var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartLightMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.232,
    height: 21.532,
    viewBox: "0 0 22.232 21.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart",
    "data-name": "Icon ionic-ios-heart",
    d: "M18.891,3.937H18.84a5.807,5.807,0,0,0-4.849,2.654A5.807,5.807,0,0,0,9.142,3.937H9.091A5.77,5.77,0,0,0,3.375,9.7a12.424,12.424,0,0,0,2.44,6.773,42.754,42.754,0,0,0,8.177,7.875,42.754,42.754,0,0,0,8.177-7.875A12.424,12.424,0,0,0,24.607,9.7,5.77,5.77,0,0,0,18.891,3.937Z",
    transform: "translate(-2.875 -3.437)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLightMd);
export default __webpack_public_path__ + "static/media/heart-light-md.08a9a93611b0d34ac5528c3ab6e2bc71.svg";
export { ForwardRef as ReactComponent };